<!-- Liste -->
<div *ngIf="!ticket" class="card">
  <div class="flex flex-wrap items-center justify-between gap-3 px-4 pt-4">
    <div>
      <h2 class="text-base font-medium m-0">Expressions de besoin</h2>
      <p class="text-secondary text-xs m-0">Tickets contenant au moins une ligne pour ce fournisseur.</p>
    </div>
    <mat-button-toggle-group [value]="status" (change)="onStatusChange($event.value)">
      <mat-button-toggle *ngFor="let statusFilter of statusFilters" [value]="statusFilter.value">
        {{ statusFilter.label }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate" class="mt-3"></mat-progress-bar>
  <div *ngIf="errorMessage" class="px-4 pt-3">
    <base-banner-message [text]="errorMessage" alertType="alert" [noMargin]="true"></base-banner-message>
  </div>

  <div *ngIf="items.length" class="api-table-wrapper mt-3">
    <table class="api-table">
      <thead>
        <tr>
          <th>N°</th>
          <th>Établissement</th>
          <th class="num">Lignes</th>
          <th class="num">Montant HT</th>
          <th>Statut</th>
          <th>Créé le</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items" class="clickable" (click)="openTicket(item)">
          <td class="font-medium">{{ item.technicalIdentifier }}</td>
          <td>{{ item.establishment?.label }}</td>
          <td class="num">{{ item.lineCount }}</td>
          <td class="num">{{ item.totalAmountHT | currency: 'EUR' }}</td>
          <td><vex-api-tester-status [status]="item.apiStatus"></vex-api-tester-status></td>
          <td>{{ item.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!loading && !errorMessage && !items.length" class="empty-state">
    Aucune expression de besoin pour ce filtre.
  </div>
  <mat-paginator
    *ngIf="pagination?.total"
    [length]="pagination.total"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50]"
    (page)="onPage($event)"
  ></mat-paginator>
</div>

<!-- Fiche -->
<ng-container *ngIf="ticket">
  <div class="breadcrumb mb-3">
    <a (click)="backToList()">Expressions de besoin</a>
    ›
    <strong>{{ ticket.technicalIdentifier }}</strong>
  </div>

  <div class="card p-4">
    <div class="flex flex-wrap items-center gap-3 mb-4">
      <h2 class="text-lg font-medium m-0">{{ ticket.technicalIdentifier }}</h2>
      <vex-api-tester-status [status]="ticket.apiStatus"></vex-api-tester-status>
      <span class="flex-auto"></span>
      <button
        mat-stroked-button
        color="warn"
        type="button"
        [disabled]="!canDecideTicket()"
        (click)="decideTicket(true)"
        matTooltip="POST /supplier/v1/tickets/:ticketId/confirm"
      >
        Refuser le ticket
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canDecideTicket()"
        (click)="decideTicket(false)"
        matTooltip="POST /supplier/v1/tickets/:ticketId/confirm"
      >
        Confirmer le ticket
      </button>
    </div>

    <dl class="fields">
      <div>
        <dt>Établissement</dt>
        <dd>{{ ticket.establishment?.label || '-' }}</dd>
      </div>
      <div>
        <dt>SIRET</dt>
        <dd>{{ ticket.establishment?.siret || '-' }}</dd>
      </div>
      <div>
        <dt>N° client</dt>
        <dd>{{ ticket.establishment?.clientNumber || '-' }}</dd>
      </div>
      <div>
        <dt>Lignes pour ce fournisseur</dt>
        <dd>{{ ticket.lineCount }}</dd>
      </div>
      <div>
        <dt>Montant HT</dt>
        <dd>{{ ticket.totalAmountHT | currency: 'EUR' }}</dd>
      </div>
      <div>
        <dt>Créé le</dt>
        <dd>{{ ticket.createdAt | date: 'dd/MM/yyyy HH:mm' }}</dd>
      </div>
    </dl>
    <p *ngIf="!canDecideTicket()" class="text-secondary text-xs mt-3 mb-0">
      Un ticket ne se confirme ou ne se refuse en bloc que s'il est « Nouveau », c'est-à-dire s'il lui reste au moins
      une ligne nouvelle.
    </p>
  </div>

  <div class="card mt-4">
    <div class="px-4 pt-4">
      <h3 class="text-base font-medium m-0">Lignes du ticket</h3>
    </div>
    <mat-progress-bar *ngIf="detailLoading" mode="indeterminate" class="mt-3"></mat-progress-bar>
    <div *ngIf="detailError" class="px-4 pt-3">
      <base-banner-message [text]="detailError" alertType="alert" [noMargin]="true"></base-banner-message>
    </div>

    <div *ngIf="lines.length" class="api-table-wrapper mt-3">
      <table class="api-table">
        <thead>
          <tr>
            <th>Réf. fournisseur</th>
            <th>Type</th>
            <th class="num">Quantité</th>
            <th class="num">Prix HT</th>
            <th>Délai de dispo.</th>
            <th>Profil proposé</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of lines">
            <td [matTooltip]="'lineId : ' + line.lineId">{{ line.supplierReference || '-' }}</td>
            <td>{{ LINE_TYPE_LABELS[line.lineType] ?? line.lineType }}</td>
            <td class="num">{{ line.quantity?.value }} {{ line.quantity?.unit }}</td>
            <td class="num">{{ line.priceExcludingTax | currency: 'EUR' }}</td>
            <td>
              <ng-container *ngIf="line.availabilityDelay?.value != null; else noValue">
                {{ line.availabilityDelay.value }} {{ DELAY_UNIT_LABELS[line.availabilityDelay.unit] }}
              </ng-container>
            </td>
            <td>
              <ng-container *ngIf="line.lineType === 'interim'; else noValue">
                <div>{{ line.interimData?.selectedProfile || 'Aucun profil' }}</div>
                <div *ngIf="line.interimData?.availabilityPeriod?.startDate" class="text-secondary text-xs">
                  du {{ line.interimData.availabilityPeriod.startDate | date: 'dd/MM/yyyy' }} au
                  {{ line.interimData.availabilityPeriod.endDate | date: 'dd/MM/yyyy' }}
                </div>
              </ng-container>
            </td>
            <td><vex-api-tester-status [status]="line.apiStatus"></vex-api-tester-status></td>
            <td class="whitespace-nowrap">
              <ng-container *ngIf="canDecideLine(line)">
                <button
                  mat-button
                  color="primary"
                  type="button"
                  (click)="decideLine(line, false)"
                  matTooltip="POST /supplier/v1/tickets/:ticketId/lines/:lineId/confirm"
                >
                  Confirmer
                </button>
                <button mat-button color="warn" type="button" (click)="decideLine(line, true)">Refuser</button>
              </ng-container>
              <ng-container *ngIf="canCompleteLine(line)">
                <button
                  mat-button
                  color="primary"
                  type="button"
                  (click)="completeLine(line, false)"
                  matTooltip="PATCH /supplier/v1/tickets/:ticketId/lines/:lineId/complete"
                >
                  Proposer un profil
                </button>
                <button mat-button color="warn" type="button" (click)="completeLine(line, true)">
                  Aucune proposition
                </button>
              </ng-container>
              <span *ngIf="!canDecideLine(line) && !canCompleteLine(line)" class="text-secondary text-xs">
                Aucune action
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!detailLoading && !detailError && !lines.length" class="empty-state">Aucune ligne.</div>
    <p *ngIf="linesTotal > lines.length" class="text-secondary text-xs px-4 py-3 m-0">
      {{ lines.length }} premières lignes affichées sur {{ linesTotal }}.
    </p>
    <p class="text-secondary text-xs px-4 py-3 m-0">
      Une ligne se confirme ou se refuse quand elle est « Nouveau ». Une ligne intérim / compétence confirmée attend
      ensuite une proposition de profil.
    </p>
  </div>
</ng-container>

<ng-template #noValue><span class="text-secondary">-</span></ng-template>
